import { Injectable } from '@angular/core';
import * as wizeMobileApi from '@wize-mobile-api';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ExchangeRates } from '@qvs/core';
import { ExchangeRatesMapper } from './exchangeRates.mapper';

@Injectable({
  providedIn: 'root'
})
export class ExchangeRatesService {
  constructor(private readonly basicDataApi: wizeMobileApi.BasicDataMobileService) {}

  loadExchangeRates(): Observable<ExchangeRates> {
    return this.basicDataApi.listExchangeRates('V').pipe(
      switchMap((exchangeRates) => {
        if (!exchangeRates) {
          return throwError(() => new Error('No exchange rates found'));
        }
        return of(ExchangeRatesMapper.fromWizeExchangeRatesToExchangeRates(exchangeRates));
      })
    );
  }
}
